export default "__VITE_ASSET__BEe04WkM__"